import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "37.5",
  width: "50",
  viewBox: "0 0 50 37.5",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#0fa0db",
    d: "M50 37.5H0V25h50v12.5z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#fff",
    d: "M50 25H0V12.5h50V25z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#ec2a3a",
    d: "M50 12.5H0V0h50v12.5z"
  })]
});